import api from '../config/axios-conf';

export const getActiveRules = () =>
    api.get('/points/active-rules');

export const getRules = () =>
    api.get('/points/rules');

export const getRule = (id) =>
    api.get(`/points/rules/${id}`);

export const createRule = (data) =>
    api.post('/points/rules', data);

export const updateRule = (id, data) =>
    api.put(`/points/rules/${id}`, data);

export const deleteRule = (id) =>
    api.delete(`/points/rules/${id}`);
